<template>
    <p class='take-effect-tip' v-if="![ESeriesCategory.CLOUD_STORAGE_PLAN,ESeriesCategory.CLOUD_RICH_NOTIFICATION_PLAN].includes(planType)">
        <span class="icon icon-co_time"></span>
        <span>
            {{
                $t('order_complete.timeNoteDataPlan')
            }}
            {{ $t('order_complete.restart_device_tip') }}
        </span>
    </p>
</template>

<script lang="ts">
import { ESeriesCategory } from '@reolink-cloud/interface';
import Vue, { PropType } from 'vue';

export default Vue.extend({
    name: 'TakeEffectTip',
    props: {
        planType: String as PropType<ESeriesCategory>
    },
    data: function() {

        return {
            ESeriesCategory
        };

    }
});
</script>

<style lang="less" scoped>
    .take-effect-tip{
        font-size: 16px;
        padding: 10px 12px;
        color: @orange_4 !important;
        background: rgba(250, 149, 80, 0.1);
        display: flex;
        gap: 8px;
        align-items: center;
        text-align: left;
        .icon{
            font-size: 20px;
        }
    }
</style>
